const data = {
  skills: [
    {
      id: 15,
      name: 'Smalltalk',
      percentage: 35
    },
    {
      id: 14,
      name: 'Prolog',
      percentage: 25
    },
    {
      id: 13,
      name: 'LISP',
      percentage: 30
    },
    {
      id: 12,
      name: 'Vue.js',
      percentage: 75
    },
    {
      id: 11,
      name: 'React.js',
      percentage: 85
    },
    {
      id: 10,
      name: 'JavaScript',
      percentage: 90
    },
    {
      id: 9,
      name: 'CSS',
      percentage: 90
    },
    {
      id: 8,
      name: 'HTML',
      percentage: 90
    },
    {
      id: 7,
      name: 'ShellScript',
      percentage: 50
    },
    {
      id: 6,
      name: 'AppleScript',
      percentage: 50
    },
    {
      id: 5,
      name: 'PHP',
      percentage: 50
    },
    {
      id: 4,
      name: 'Ruby',
      percentage: 50
    },
    {
      id: 3,
      name: 'Python',
      percentage: 80
    },
    {
      id: 2,
      name: 'Java',
      percentage: 75
    },
    {
      id: 1,
      name: 'C言語',
      percentage: 80
    }
  ]
}

export default data
